import { render, staticRenderFns } from "./RuleSearch.vue?vue&type=template&id=34aafb55"
import script from "./RuleSearch.vue?vue&type=script&lang=js"
export * from "./RuleSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports